import { z, type infer as zInfer } from "zod";
import { timestamp } from "@/hooks/firestore/models/timestamp";

export const casinoGame = z.object({
  languages: z.array(z.string()),
  productLogoUrl: z.string(),
  releaseDate: timestamp,
  manualLaunchDate: timestamp.nullable(),
  technology: z.array(z.string()),
  priority: z.number(), // global order, set by backend: views without a single category, a category filtered by provider, and release date ties
  productName: z.string(),
  platforms: z.array(z.enum(["GPL_DESKTOP", "GPL_MOBILE"])),
  allowedCountries: z.array(z.string()),
  name: z.string(),
  urlThumbnail: z.string(),
  gameCode: z.string(),
  categories: z.array(z.string()), // casinoCategoriesV2 doc ids
  categoryPriorities: z.record(z.string(), z.number()), // category id -> priority
  urlBackground: z.string(),
  description: z.string().nullish(),
  slug: z.string(), // game name converted to a sanitised string
  productSlug: z.string(), // this is provider, may get renamed
  demoGameSupport: z.boolean(),
  multiBoxSupport: z.boolean().nullable(),
  rtp: z.string(),
  rakebackPercent: z.number(),
});

export type CasinoGame = zInfer<typeof casinoGame>;
